import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    guestDetails: {
        lastName: '',
        roomNumber: '',
        confirmationNumber: '',
        checkinDate: '',
        candoAccompanyLogin: true,
        candoOtpFlow: true
    },
    widgetSessionId: '',
    activeState: '',
    guestList: [],
    otpMessage: ''
};

const guestRoomSlice = createSlice({
  name: 'guestRoom',
  initialState,
  reducers: {
    setGuestRoomData: (state, action) => {
        const { guestDetails, activeState, widgetSessionId, guestList, otpMessage } = action.payload;
        state.guestDetails = {
            ...state.guestDetails,
            ...guestDetails
        };
        state.widgetSessionId = widgetSessionId,
        state.activeState = activeState;
        state.guestList = guestList;
        state.otpMessage = otpMessage;
    },
    resetGuestRoomState: (state, action) => {

        if(!action?.payload?.donotResetGuestDetails) {
            state.guestDetails = {
                lastName: '',
                roomNumber: '',
                confirmationNumber: '',
                checkinDate: '',
                candoAccompanyLogin: true,
                candoOtpFlow: true
            };
        }
        state.activeState = '';
        state.widgetSessionId = '';
        state.guestList = [];
        state.otpMessage = '';
    },
  },
});

export const {
    setGuestRoomData,
    resetGuestRoomState,
} = guestRoomSlice.actions;

export default guestRoomSlice.reducer;
